<app-navbar [title]="template.name">
	<button class="btn btn-warning" (click)="submit()"><i class="fas fa-check"></i> Zapisz</button>
</app-navbar>

<app-map-timetable [(data)]="data" [citiesConnections]="citiesConnections" [side]="template.side"></app-map-timetable>
